webpackJsonp([2],{

/***/ "3R8x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MIpt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/_vue@2.5.2@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("MVSX");

// EXTERNAL MODULE: ./node_modules/_fastclick@1.0.6@fastclick/lib/fastclick.js
var fastclick = __webpack_require__("iDdd");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/_vux@2.7.8@vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("xYjr");

// EXTERNAL MODULE: ./node_modules/_vux@2.7.8@vux/src/plugins/toast/index.js
var toast = __webpack_require__("T50h");

// EXTERNAL MODULE: ./node_modules/_vux@2.7.8@vux/src/plugins/loading/index.js
var loading = __webpack_require__("FtCK");

// EXTERNAL MODULE: ./node_modules/_vux@2.7.8@vux/src/plugins/confirm/index.js
var plugins_confirm = __webpack_require__("nVmn");

// EXTERNAL MODULE: ./node_modules/_vux@2.7.8@vux/src/plugins/wechat/index.js
var wechat = __webpack_require__("p9JK");

// EXTERNAL MODULE: ./node_modules/_vuex@3.0.1@vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("9rMa");

// CONCATENATED MODULE: ./src/store/index.js


vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);
var store = new vuex_esm["a" /* default */].Store({
  strict: true
});

/* harmony default export */ var src_store = (store);
// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("3cXf");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("hRKE");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./src/libs/sess.js


/* harmony default export */ var sess = ({
  get: function get(name) {
    var value = sessionStorage.getItem(name);
    if (/^\{.*\}$/.test(value)) value = JSON.parse(value);
    return value;
  },
  set: function set(name, value) {
    if ((typeof value === "undefined" ? "undefined" : typeof_default()(value)) === typeof_default()({})) value = stringify_default()(value);
    return sessionStorage.setItem(name, value);
  },
  remove: function remove(name) {
    return sessionStorage.removeItem(name);
  }
});
// EXTERNAL MODULE: ./node_modules/_vue-router@3.0.1@vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("zO6J");

// EXTERNAL MODULE: ./src/plugins/mobile.js
var mobile = __webpack_require__("Pg5v");
var mobile_default = /*#__PURE__*/__webpack_require__.n(mobile);

// CONCATENATED MODULE: ./src/route/index.js
var Index = function Index(resolve) {
    return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("rCZN")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var routes = [{
    path: '/acthome/juhe/:cityid',
    name: 'juhe',
    component: Index
}];

/* harmony default export */ var route = (routes);
// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/promise.js
var promise = __webpack_require__("rVsN");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/_axios@0.15.3@axios/index.js
var _axios_0_15_3_axios = __webpack_require__("6sKG");
var _axios_0_15_3_axios_default = /*#__PURE__*/__webpack_require__.n(_axios_0_15_3_axios);

// EXTERNAL MODULE: ./node_modules/_vux@2.7.8@vux/src/tools/cookie/index.js
var cookie = __webpack_require__("7XTc");
var cookie_default = /*#__PURE__*/__webpack_require__.n(cookie);

// EXTERNAL MODULE: ./node_modules/_vux@2.7.8@vux/src/tools/querystring/index.js
var querystring = __webpack_require__("MQUI");
var querystring_default = /*#__PURE__*/__webpack_require__.n(querystring);

// CONCATENATED MODULE: ./src/plugins/headers.js
/**
 * cookie里的信息
 */

var headerList = function headerList(cookielist) {

    var Authorization = '',
        city_id = 0,
        app_key = 'hunbasha_wap',
        jid = '',
        app_channel = '',
        app_version = '',
        pageId = '',
        device_id = '';

    if (cookielist) {
        var cookieArr = cookielist.split(';');
        for (var i in cookieArr) {
            var cookie = cookieArr[i].replace(/(^\s*)|(\s*$)/g, "");
            var index = cookie.indexOf('=');
            var name = cookie.substr(0, index);
            var value = decodeURIComponent(cookie.substr(index + 1));
            switch (name) {
                case 'Authorization':
                    if (value) {
                        if (/^dmp/.test(value)) {
                            Authorization = value;
                        } else {
                            Authorization = 'dmp ' + value;
                        }
                    }
                    break;
                case 'jhu':
                    if (!Authorization && value) {
                        if (/^dmp/.test(value)) {
                            Authorization = value;
                        } else {
                            Authorization = 'dmp ' + value;
                        }
                    }
                    break;
                case 'city-id':
                    city_id = value;
                    break;
                case 'app-key':
                    app_key = value;
                    break;
                case 'jid':
                    jid = value;
                    break;
                case 'clientId':
                    jid = value;
                    break;
                case 'client-id':
                    jid = value;
                    break;
                case 'app-channel':
                    app_channel = value;
                    break;
                case 'app-version':
                    app_version = value;
                    break;
                case 'page-id':
                    pageId = value;
                    break;
                case 'deviceId':
                    device_id = value;
                    break;
                case 'device-id':
                    device_id = value;
                    break;
            }
        }
    }

    var arr = location.pathname.split('/');
    if (location.pathname.indexOf('acthome/juhe/')) {
        city_id = arr[3];
    }

    return {
        Authorization: Authorization,
        city_id: city_id,
        app_key: app_key,
        jid: jid,
        app_version: app_version,
        app_channel: app_channel,
        device_id: device_id,
        pageId: pageId
    };
};

/* harmony default export */ var headers = (headerList);
// CONCATENATED MODULE: ./src/libs/http.js









if (!cookie_default.a.get('Authorization') && querystring_default.a.parse().jhu) {
  cookie_default.a.set('Authorization', querystring_default.a.parse().jhu);
}

var http_Authorization = cookie_default.a.get('Authorization');
var http_jhu = cookie_default.a.get('jhu');
if (http_Authorization) {
  if (/^dmp/.test(http_Authorization)) {
    http_Authorization = http_Authorization;
  } else {
    http_Authorization = 'dmp ' + http_Authorization;
  }
} else if (http_jhu) {
  if (/^dmp/.test(http_jhu)) {
    http_Authorization = http_jhu;
  } else {
    http_Authorization = 'dmp ' + http_jhu;
  }
}

function generateUUID() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-yxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
}

var http_headerList = headers(document.cookie);
var city_id = http_headerList.city_id,
    app_key = http_headerList.app_key,
    jid = http_headerList.jid,
    app_version = http_headerList.app_version,
    app_channel = http_headerList.app_channel,
    pageId = http_headerList.pageId;

if (!jid || jid == 'undefined') {
  jid = generateUUID();
  cookie_default.a.set('jid', jid, {
    maxAge: 60000 * 60 * 24 * 365,
    domain: ".jiehun.com.cn",
    path: '/'
  });
}

if (!pageId) {
  pageId = generateUUID();
  cookie_default.a.set('page-id', pageId, {
    path: '/'
  });
}

var http = _axios_0_15_3_axios_default.a.create({
  baseURL: "https://open.jiehun.com.cn",
  timeout: 15000,
  headers: {
    'Authorization': http_Authorization,
    'city-id': city_id,
    'app-key': app_key,
    'app-version': app_version,
    'app-channel': app_channel,
    'client-id': jid,
    'page-id': pageId
  }
});

http.interceptors.request.use(function (config) {

  var Authorization = cookie_default.a.get('Authorization');
  var jhu = cookie_default.a.get('jhu');
  if (Authorization) {
    if (/^dmp/.test(Authorization)) {
      Authorization = Authorization;
    } else {
      Authorization = 'dmp ' + Authorization;
    }
  } else if (jhu) {
    if (/^dmp/.test(jhu)) {
      Authorization = jhu;
    } else {
      Authorization = 'dmp ' + jhu;
    }
  }
  config.headers['Authorization'] = Authorization;

  return config;
}, function (error) {

  return promise_default.a.reject(error);
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {

  return promise_default.a.reject(error);
});

/* harmony default export */ var libs_http = ({
  get: function get(url) {
    return new promise_default.a(function (resolve, reject) {
      http.get(url).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        if (error.response) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      });
    });
  },
  post: function post(url, params) {
    return new promise_default.a(function (resolve, reject) {

      http.post(url, params).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {

        console.log('断网错误码', error);
        vue_esm["a" /* default */].$vux.toast.text('网络链接异常，请重试');
        if (error.response) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.1@babel-loader/lib!./node_modules/_vux-loader@1.1.30@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.3.0@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.3.0@vue-loader/lib/template-compiler?{"id":"data-v-17410276","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.1.30@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.1.30@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("3R8x")
}
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./src/plugins/browser.js
var browser = __webpack_require__("jYaQ");

// EXTERNAL MODULE: ./node_modules/_vue-awesome-swiper@3.1.3@vue-awesome-swiper/dist/vue-awesome-swiper.js
var vue_awesome_swiper = __webpack_require__("DMPO");
var vue_awesome_swiper_default = /*#__PURE__*/__webpack_require__.n(vue_awesome_swiper);

// EXTERNAL MODULE: ./node_modules/_swiper@4.5.1@swiper/dist/css/swiper.css
var swiper = __webpack_require__("t7ww");
var swiper_default = /*#__PURE__*/__webpack_require__.n(swiper);

// CONCATENATED MODULE: ./src/main.js
























vue_esm["a" /* default */].use(vue_awesome_swiper_default.a /* { default global options } */);
vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
vue_esm["a" /* default */].use(plugins_alert["a" /* default */]);
vue_esm["a" /* default */].use(toast["a" /* default */]);
vue_esm["a" /* default */].use(loading["a" /* default */]);
vue_esm["a" /* default */].use(plugins_confirm["a" /* default */]);
vue_esm["a" /* default */].use(wechat["a" /* default */]);
vue_esm["a" /* default */].prototype.$sess = sess;
vue_esm["a" /* default */].prototype.$cookie = cookie_default.a;
vue_esm["a" /* default */].prototype.$http = libs_http;
vue_esm["a" /* default */].prototype.$browser = Object(browser["a" /* default */])();

var router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: route
});
fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

window.$action = new postdata({
  appkey: 'hunbasha_wap',
  pageid_type: true,
  pageName: '/acthome/juhe/~city',
  sensor_option: {
    openAll: true
  }
});
console.log('1');

router.beforeEach(function (to, from, next) {
  next();
});
router.afterEach(function (toRoute, fromRoute) {
  var to = toRoute.path;
  var h = sess.get(to);
  if (h && h.scrollTop >= 0) {
    vue_esm["a" /* default */].nextTick(function () {
      window.scroll(0, h.scrollTop);
    });
  }
  if (window.gtag) {
    var pageVal = toRoute.fullPath;
    gtag('event', 'set', { 'page': 'page', 'pageVal': pageVal });
    gtag('event', 'send', { 'pageview': 'pageview' });
  }
});
/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  store: src_store,
  router: router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "Ot2K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.7.8@vux/src/components/x-dialog/index.vue + 2 modules
var x_dialog = __webpack_require__("ag88");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.1@babel-loader/lib!./node_modules/_vux-loader@1.1.30@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.3.0@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.7.8@vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus() {
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.3.0@vue-loader/lib/template-compiler?{"id":"data-v-784eca68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.1.30@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.1.30@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.3.0@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.7.8@vux/src/components/confirm/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt",on:{"touchstart":function($event){$event.preventDefault();_vm.setInputFocus($event)}}},[_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder},domProps:{"value":(_vm.msg)},on:{"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.inputAttrs,false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]),_vm._v(" "),_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_confirm = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.7.8@vux/src/components/confirm/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("wLl/")
}
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_confirm,
  src_components_confirm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var _vux_2_7_8_vux_src_components_confirm = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Pg5v":
/***/ (function(module, exports) {

!function (doc, win) {
    var defaults = {
        baseFontSize: 50,
        maxWidth: 750,
        minWidth: 190
    },
        conf = {};
    for (var key in defaults) {
        if (defaults.hasOwnProperty(key)) {
            conf[key] = defaults[key];
        }
    }

    var lastWidth, deviceWidth;

    /**
     * 重新调整rem的大小
     */
    function resizeRem() {
        var curWidth = 0;
        if (!deviceWidth && window.aji && window.aji.getDeviceWidth) {
            deviceWidth = window.aji.getDeviceWidth();
        }
        if (deviceWidth) {
            curWidth = deviceWidth / window.devicePixelRatio;
        } else {
            curWidth = Math.min(screen.availWidth, doc.documentElement.clientWidth);
        }

        if (!curWidth || curWidth == lastWidth) {
            return;
        }
        var HtmlSize = doc.querySelector('html').style;
        if (curWidth > conf.maxWidth) {
            HtmlSize.fontSize = conf.baseFontSize + 'px';
        } else if (curWidth < conf.minWidth) {
            HtmlSize.fontSize = conf.minWidth / conf.maxWidth * conf.baseFontSize + 'px';
        } else {
            HtmlSize.fontSize = curWidth / conf.maxWidth * conf.baseFontSize + 'px';
        }
        lastWidth = curWidth;
    }
    resizeRem();
    win.addEventListener('resize', resizeRem);
}(document, window);

/***/ }),

/***/ "XIkm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.7.8@vux/src/components/x-dialog/index.vue + 2 modules
var x_dialog = __webpack_require__("ag88");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.1@babel-loader/lib!./node_modules/_vux-loader@1.1.30@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.3.0@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.7.8@vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.3.0@vue-loader/lib/template-compiler?{"id":"data-v-7104cd78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.1.30@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.1.30@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.3.0@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.7.8@vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')},"on-show":function($event){_vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.7.8@vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("MIpt")
}
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_alert,
  src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var _vux_2_7_8_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ag88":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.7.8@vux/src/mixins/prevent-body-scroll.js + 1 modules
var prevent_body_scroll = __webpack_require__("px/9");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.1@babel-loader/lib!./node_modules/_vux-loader@1.1.30@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.3.0@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.7.8@vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.3.0@vue-loader/lib/template-compiler?{"id":"data-v-c31bd7aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.1.30@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.1.30@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.3.0@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.7.8@vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.7.8@vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("cRkD")
}
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  x_dialog,
  components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cEiM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cRkD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dcH8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.1@babel-loader/lib!./node_modules/_vux-loader@1.1.30@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.3.0@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.7.8@vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.3.0@vue-loader/lib/template-compiler?{"id":"data-v-5e44d9e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.1.30@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.1.30@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.3.0@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.7.8@vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading"},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({ position: _vm.position })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.7.8@vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("cEiM")
}
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  loading,
  components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jYaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("ZLEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_tools_cookie_index_js__ = __webpack_require__("7XTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_tools_cookie_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_tools_cookie_index_js__);

/**
* 浏览器信息
*/


function browers() {
  var ua = navigator.userAgent.toLowerCase(),
      rwebkit = /(webkit)[ \/]([\w.]+)/,
      ropera = /(opera)(?:.*version)?[ \/]([\w.]+)/,
      rmsie = /(msie) ([\w.]+)/,
      rmozilla = /(mozilla)(?:.*? rv:([\w.]+))?/,
      match = rwebkit.exec(ua) || ropera.exec(ua) || rmsie.exec(ua) || ua.indexOf('compatible') < 0 && rmozilla.exec(ua) || [];

  var extraMs = [],
      extra = {};
  extraMs = /<<([a-z0-9]+\=\w*(?:&[a-z0-9]+\=[\w\.]*)*)>>/.exec(ua.replace('$s=', '&s='));
  if (extraMs && extraMs.length > 0) {
    var arr = extraMs[1].split('&');
    for (var i in arr) {
      var ar = arr[i].split('=');
      extra[ar[0]] = ar[1];
    }
  }

  var isApp = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(extra).length;
  var hasAppKey = __WEBPACK_IMPORTED_MODULE_1_vux_src_tools_cookie_index_js___default.a.get('app-key') == 'hunbasha_ios' || __WEBPACK_IMPORTED_MODULE_1_vux_src_tools_cookie_index_js___default.a.get('app-key') == 'hunbasha_android' ? true : false;
  var usa = navigator.userAgent;
  return {
    type: match[1] || '',
    version: match[2] || '0',
    mobile: /(MIDP|WAP|UP\.Browser|Smartphone|Obigo|AU\.Browser|wxd\.Mms|WxdB\.Browser|CLDC|UP\.Link|KM\.Browser|UCWEB|UCBrowser|SEMC\-Browser|Mini|Symbian|Palm|Nokia|Panasonic|MOT|SonyEricsson|NEC|Alcatel|Ericsson|BENQ|BenQ|Amoisonic|Amoi|Capitel|PHILIPS|SAMSUNG|Lenovo|Mitsu|Motorola|SHARP|WAPPER|LG|EG900|CECT|Compal|kejian|Bird|BIRD|G900\/V1\.0|Arima|CTL|TDG|Daxian|DAXIAN|DBTEL|Eastcom|EASTCOM|PANTECH|Dopod|Haier|HAIER|KONKA|KEJIAN|LENOVO|Soutec|SOUTEC|SAGEM|SEC|SED|EMOL|INNO55|ZTE|iPhone|Android|Windows CE|BlackBerry|MicroMessenger)/i.test(navigator.userAgent),
    android: ua.indexOf('android') > -1,
    ios: /(ipad|ios|iphone)/.test(ua),
    weixin: usa.indexOf('MicroMessenger') > -1,
    qq: usa.indexOf('MQQBrowser') > -1 || usa.indexOf('QQ/') > -1,
    userAgent: usa,
    extra: extra,
    isApp: isApp || hasAppKey
  };
}

/* harmony default export */ __webpack_exports__["a"] = (browers);

/***/ }),

/***/ "k/kc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.7.8@vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("a089");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.1@babel-loader/lib!./node_modules/_vux-loader@1.1.30@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.3.0@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.7.8@vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.3.0@vue-loader/lib/template-compiler?{"id":"data-v-6605644f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.1.30@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.1.30@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.3.0@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.7.8@vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.7.8@vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("kX98")
}
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  toast,
  components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kX98":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t7ww":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wLl/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e07eeccfec89db5f5e32.js